import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=1c68bcb4"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=js"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCompleted.vue?vue&type=style&index=0&id=1c68bcb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports